// extracted by mini-css-extract-plugin
export var parcelRow = "_vl-0";